import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Landmark } from "lucide-react";
import { api, apiError } from "@/lib/api";

export const PayoutCard = ({ profile, onSaved }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setEmail(profile?.paypal_email || "");
  }, [profile?.paypal_email]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/profile/payout", { paypal_email: email });
      toast.success(data.released ? `Email PayPal salvata • ${data.released} pagamenti Escrow inviati` : "Email PayPal salvata");
      onSaved();
    } catch (err) {
      toast.error(apiError(err, "Email PayPal non valida"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="payout-card" className="mt-6 ff-card p-4 flex flex-col gap-3">
      <span className="ff-label !mb-0 flex items-center gap-2"><Landmark size={15} /> Conto incassi PayPal</span>
      <p data-testid="payout-status" className="text-sm text-white">
        {profile?.payouts_ready ? "Attivo: ricevi in automatico su PayPal il 90% delle corse che cedi, a corsa completata." : "Inserisci l'email del tuo conto PayPal per ricevere in automatico il 90% delle corse che cedi."}
      </p>
      <input type="email" required data-testid="payout-email-input" className="ff-field" placeholder="email@paypal.it" value={email} onChange={(e) => setEmail(e.target.value)} />
      <button type="submit" data-testid="payout-save-button" disabled={busy} className="ff-btn-secondary w-full text-sm uppercase border-[#10B981]">
        {busy ? "Salvataggio…" : profile?.payouts_ready ? "AGGIORNA EMAIL PAYPAL" : "ATTIVA INCASSI PAYPAL"}
      </button>
    </form>
  );
};
